import { cache } from 'react'

import getGraphqlForServer from '../../../../lib/get-graphql-for-server'
import { EventType } from '../../../../App.types'

import formatQueryParams from './helpers/format-query-params'
import { FILTER_KEY_URL_PARAMS } from './components/Filters/Filters.types'

export const EVENT_LIMIT = 18
export const EVENT_TYPES = [EventType.CLASS, EventType.TRAINING]

interface Props {
  citySlug: string
  sportSlug: string
  searchParams: { [key: string]: string | Array<string> | undefined }
}

export const getData = cache(async ({ citySlug, sportSlug, searchParams }: Props) => {
  // TODO - see if this can be done in the formatQueryParams itself
  // Problem is that the TYPE of this "searchParams" on the server is different than that returned by the useSearchParams() hook on the client
  const eventFiltersFromUrlParams = formatQueryParams({
    dateParam: searchParams?.[FILTER_KEY_URL_PARAMS.DATE],
    timeParam: searchParams?.[FILTER_KEY_URL_PARAMS.START_TIME],
    activityLocationParam: searchParams?.[FILTER_KEY_URL_PARAMS.ACTIVITY_LOCATION],
    levelParam: searchParams?.[FILTER_KEY_URL_PARAMS.LEVEL],
  })

  try {
    const response = await getGraphqlForServer().DiscoverActivitiesDiscoverContextByCityAndSportSlug({
      citySlug,
      sportSlug: decodeURIComponent(sportSlug),
      first: EVENT_LIMIT,
      eventTypes: EVENT_TYPES,
      ...eventFiltersFromUrlParams,
    })
    return { data: response.discoverContextByCityAndSportSlug }
  } catch (error: unknown) {
    return { error }
  }
})
